/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { T, SYSTEM_LISTS_DEFAULTS, isCompactViewport } from "../../lib/globals";
import { fmtDate, today, compressImage } from "../../lib/formatters";
import { Btn, Modal, Field, Badge, CCBadge, Input, Select, Textarea, StatCard, Toast, useToast } from "../ui";
import { getPriorityConfig, SVC_STATUS_FLOW } from "./servicesConstants";
import { ServicePhotoAddPhoneIcon, ServicePhotoStatusIcon, normalizePhotoEntries, ServicePhotosModal } from "./servicesPhotos";
import { ColActionButtons } from "./servicesActions";

function ServiceDenyModal({denyReasons, onClose, onConfirm}) {
  const [reason, setReason] = useState((denyReasons||["Outro motivo"])[0]);
  const [custom, setCustom] = useState("");
  return(
    <Modal open={true} onClose={onClose} title="❌ Negar Orçamento">
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <Field label="Motivo *">
          <Select value={reason} onChange={e=>setReason(e.target.value)}>
            {(denyReasons||["Outro motivo"]).map(r=><option key={r}>{r}</option>)}
          </Select>
        </Field>
        {reason==="Outro motivo"&&<Field label="Descreva">
          <Textarea rows={2} value={custom} onChange={e=>setCustom(e.target.value)}/>
        </Field>}
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <Btn variant="ghost" onClick={onClose}>Cancelar</Btn>
          <Btn variant="danger" onClick={()=>onConfirm(reason==="Outro motivo"?custom||reason:reason)}>❌ Confirmar</Btn>
        </div>
      </div>
    </Modal>
  );
}


function PauseTaskModal({ title="⏸️ Pausar Tarefa", reasons=[], initialReason="", initialObs="", onClose, onSave }) {
  const [reason, setReason] = useState(initialReason || reasons[0] || "");
  const [obs, setObs] = useState(initialObs || "");
  return (
    <Modal open={true} onClose={onClose} title={title} zIndex={1200}>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        <Field label="Justificativa *">
          <Select value={reason} onChange={e=>setReason(e.target.value)}>
            {(reasons||[]).map(r=><option key={r}>{r}</option>)}
          </Select>
        </Field>
        <Field label="Observação">
          <Textarea rows={3} value={obs} onChange={e=>setObs(e.target.value)} placeholder="Detalhes adicionais (opcional)"/>
        </Field>
        <div style={{display:"flex",justifyContent:"flex-end",gap:10}}>
          <Btn variant="ghost" onClick={onClose}>Cancelar</Btn>
          <Btn onClick={()=>onSave({reason,obs})}>Salvar Pausa</Btn>
        </div>
      </div>
    </Modal>
  );
}


function MaterialsModal({stockItems, onClose, onSave}) {
  const [items, setItems] = useState([{stockId:"",qtySeparated:"",qtyUsed:""}]);
  return(
    <Modal open={true} onClose={onClose} title="📦 Adicionar Materiais" wide zIndex={1200}>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <div style={{background:`${T.yellow}15`,border:`1px solid ${T.yellow}44`,borderRadius:8,padding:"8px 12px",fontSize:12,color:T.yellow}}>
          ⚠️ A quantidade separada sai do estoque imediatamente. Se a utilizada for menor, a diferença retorna automaticamente ao estoque.
        </div>
        {items.map((item,i)=>{
          const selected = (stockItems||[]).find(s=>String(s.id)===String(item.stockId));
          return(
            <div key={i} style={{display:"grid",gridTemplateColumns:"1.4fr 110px 110px auto",gap:8,alignItems:"flex-end"}}>
              <Field label={i===0?"Produto":""}>
                <Select value={item.stockId} onChange={e=>setItems(it=>it.map((x,j)=>j===i?{...x,stockId:e.target.value}:x))}>
                  <option value="">Selecione...</option>
                  {(stockItems||[]).map(s=><option key={s.id} value={s.id}>{s.name} (saldo: {s.quantity||0} {s.unit})</option>)}
                </Select>
              </Field>
              <Field label={i===0?"Separada":""}>
                <Input type="number" min="0.001" step="0.001" value={item.qtySeparated}
                  onChange={e=>setItems(it=>it.map((x,j)=>j===i?{...x,qtySeparated:e.target.value}:x))}/>
              </Field>
              <Field label={i===0?"Utilizada":""}>
                <Input type="number" min="0" step="0.001" value={item.qtyUsed}
                  onChange={e=>setItems(it=>it.map((x,j)=>j===i?{...x,qtyUsed:e.target.value}:x))}
                  placeholder={selected?.unit||""}/>
              </Field>
              <button onClick={()=>setItems(it=>it.filter((_,j)=>j!==i))}
                style={{background:"none",border:"none",color:T.red,cursor:"pointer",fontSize:18,paddingBottom:2}}>×</button>
            </div>
          );
        })}
        <Btn size="sm" variant="ghost" onClick={()=>setItems(it=>[...it,{stockId:"",qtySeparated:"",qtyUsed:""}])}>+ Item</Btn>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <Btn variant="ghost" onClick={onClose}>Cancelar</Btn>
          <Btn onClick={()=>onSave(items)}>📦 Confirmar</Btn>
        </div>
      </div>
    </Modal>
  );
}


function NFModal({onClose, onSave}) {
  const [nfNum,   setNfNum]   = useState("");
  const [nfPhoto, setNfPhoto] = useState("");
  const [finalValue,setFinalValue] = useState("");
  const [dueDate, setDueDate] = useState(today());
  const [paymentMethod,setPaymentMethod] = useState("");
  const [justificationMissing,setJustificationMissing] = useState("");
  function pickPhoto(){
    const inp=document.createElement("input");inp.type="file";inp.accept="image/*";
    inp.onchange=e=>{const f=e.target.files[0];if(!f)return;const r=new FileReader();r.onload=ev=>setNfPhoto(ev.target.result);r.readAsDataURL(f);};
    inp.click();
  }
  return(
    <Modal open={true} onClose={onClose} title="📄 Concluir com Nota Fiscal">
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <Field label="Número da NF">
          <Input value={nfNum} onChange={e=>setNfNum(e.target.value)} placeholder="Ex: 001234"/>
        </Field>
        <div style={{display:"grid",gridTemplateColumns:"repeat(2,minmax(0,1fr))",gap:12}}>
          <Field label="Valor final do serviço (R$)">
            <Input type="number" min="0" step="0.01" value={finalValue} onChange={e=>setFinalValue(e.target.value)} placeholder="Opcional"/>
          </Field>
          <Field label="Vencimento / pagamento">
            <Input type="date" value={dueDate} onChange={e=>setDueDate(e.target.value)}/>
          </Field>
          <Field label="Forma de pagamento">
            <Select value={paymentMethod} onChange={e=>setPaymentMethod(e.target.value)}>
              <option value="">Selecione...</option>
              {["PIX","Boleto","Dinheiro","Cartão","Transferência","Prazo","Outro"].map(opt=><option key={opt}>{opt}</option>)}
            </Select>
          </Field>
          <Field label="Justificativa se faltar valor/NF">
            <Input value={justificationMissing} onChange={e=>setJustificationMissing(e.target.value)} placeholder="Explique ausência de informação"/>
          </Field>
        </div>
        <Field label="Foto da NF">
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            {nfPhoto&&<img src={nfPhoto} alt="" style={{width:60,height:60,objectFit:"cover",borderRadius:8}}/>}
            <button onClick={pickPhoto}
              style={{padding:"8px 16px",borderRadius:8,border:`1px dashed ${T.border}`,background:T.card2,cursor:"pointer",color:T.muted,fontSize:13}}>
              📷 {nfPhoto?"Trocar":"Adicionar"}
            </button>
          </div>
        </Field>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <Btn variant="ghost" onClick={onClose}>Cancelar</Btn>
          <Btn onClick={()=>onSave({nfNum,nfPhoto,finalValue,dueDate,paymentMethod,justificationMissing})}>✅ Concluir Serviço</Btn>
        </div>
      </div>
    </Modal>
  );
}


function ServiceDetailModal({ svc, canManage, myName, show, pastureMap, poiMap, colAction, requestMaterials, conclude, justifyDelay, emit, onClose, onEdit, STATUS_CONFIG }) {
  if(!svc) return null;
  const cfg = STATUS_CONFIG[svc.status] || { color:"#64748B", icon:"📋" };

  return(
    <Modal open={true} onClose={onClose} title="" wide>
      <div style={{display:"flex",flexDirection:"column",gap:0}}>
        {/* Header */}
        <div style={{background:`${cfg.color}18`,borderRadius:12,padding:"16px 18px",marginBottom:16,border:`1px solid ${cfg.color}33`}}>
          <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
            <span style={{fontSize:32}}>{cfg.icon}</span>
            <div style={{flex:1}}>
              <div style={{fontWeight:800,color:T.text,fontSize:17,marginBottom:4}}>{svc.title}</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                <Badge color={cfg.color}>{cfg.icon} {svc.status}</Badge>
                {svc.serviceType&&<Badge color={T.accent}>{svc.serviceType}</Badge>}
                {svc.costCenter&&<CCBadge cc={svc.costCenter}/>}
              </div>
            </div>
            {canManage&&<Btn size="sm" variant="ghost" onClick={onEdit}>✏️ Editar</Btn>}
          </div>
        </div>

        {/* Info grid */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
          {svc.pastureId&&pastureMap[svc.pastureId]&&(
            <div style={{background:T.card2,borderRadius:8,padding:"10px 12px"}}>
              <div style={{fontSize:10,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:.8}}>📍 Local</div>
              <div style={{color:T.text,fontWeight:600,fontSize:13,marginTop:4}}>{pastureMap[svc.pastureId]}</div>
            </div>
          )}
          {svc.dateStart&&(
            <div style={{background:T.card2,borderRadius:8,padding:"10px 12px"}}>
              <div style={{fontSize:10,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:.8}}>📅 Início</div>
              <div style={{color:T.text,fontWeight:600,fontSize:13,marginTop:4}}>{fmtDate(svc.dateStart)}</div>
            </div>
          )}
          {svc.deadline&&(
            <div style={{background:T.card2,borderRadius:8,padding:"10px 12px",border:new Date(svc.deadline)<new Date()?`1px solid ${T.red}44`:undefined}}>
              <div style={{fontSize:10,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:.8}}>⏰ Prazo</div>
              <div style={{color:new Date(svc.deadline)<new Date()?T.red:T.text,fontWeight:600,fontSize:13,marginTop:4}}>{fmtDate(svc.deadline)}</div>
            </div>
          )}
          {svc.scheduledDate&&(
            <div style={{background:T.card2,borderRadius:8,padding:"10px 12px"}}>
              <div style={{fontSize:10,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:.8}}>📅 Agendado Para</div>
              <div style={{color:T.purple,fontWeight:600,fontSize:13,marginTop:4}}>{fmtDate(svc.scheduledDate)}</div>
            </div>
          )}
        </div>

        {/* Delay justification badge */}
        {svc.delayJustification&&(
          <div style={{background:`${T.red}12`,border:`1px solid ${T.red}44`,borderRadius:10,padding:"10px 14px",marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:24}}>{svc.delayJustification.icon}</span>
            <div>
              <div style={{fontSize:11,fontWeight:700,color:T.red,textTransform:"uppercase",letterSpacing:.8}}>Atraso Justificado</div>
              <div style={{fontSize:13,color:T.text,marginTop:2}}>{svc.delayJustification.label}</div>
              {svc.delayJustification.by&&<div style={{fontSize:10,color:T.muted,marginTop:2}}>por {svc.delayJustification.by}</div>}
            </div>
          </div>
        )}

        {/* Description */}
        {svc.description&&(
          <div style={{background:T.card2,borderRadius:8,padding:"12px 14px",marginBottom:16}}>
            <div style={{fontSize:10,color:T.muted,fontWeight:700,textTransform:"uppercase",letterSpacing:.8,marginBottom:6}}>📝 Descrição</div>
            <div style={{fontSize:13,color:T.text,lineHeight:1.7}}>{svc.description}</div>
          </div>
        )}

        {/* Assignees */}
        {(svc.assignees||[]).length>0&&(
          <div style={{marginBottom:16}}>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:.8,marginBottom:8}}>👥 Colaboradores</div>
            <div style={{display:"flex",flexDirection:"column",gap:6}}>
              {svc.assignees.map((a,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",background:T.card2,borderRadius:8,border:`1px solid ${T.border}`}}>
                  <div style={{width:32,height:32,borderRadius:"50%",background:`${T.accent}22`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}>👤</div>
                  <span style={{fontWeight:600,color:T.text,fontSize:13,flex:1}}>{a.name}</span>
                  {a.status&&<Badge color={(STATUS_CONFIG[a.status]||{color:T.muted}).color}>{a.status}</Badge>}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Completion photos */}
        {svc.status==="Concluído"&&(svc.completionPhotos||[]).length>0&&(
          <div style={{marginBottom:16}}>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:.8,marginBottom:8}}>📷 Fotos da Conclusão</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {(svc.completionPhotos||[]).map((ph,i)=>(
                <img key={i} src={ph} alt="" style={{width:80,height:80,objectFit:"cover",borderRadius:10,border:`1px solid ${T.border}`,cursor:"zoom-in"}}
                  onClick={()=>window.open(ph,"_blank")}/>
              ))}
            </div>
            {svc.completionNote&&<div style={{fontSize:12,color:T.muted,marginTop:8,fontStyle:"italic"}}>"{svc.completionNote}"</div>}
          </div>
        )}

        {/* Collaborator actions */}
        {!canManage&&(svc.assignees||[]).map(a=>typeof a === "string" ? a : (a?.name||"")).includes(myName)&&!["Concluído","Cancelado"].includes(svc.status)&&(
          <div style={{marginBottom:16,padding:"14px 16px",background:T.card2,borderRadius:10,border:`1px solid ${T.border}`}}>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:.8,marginBottom:10}}>⚡ Suas Ações</div>
            <ColActionButtons svc={svc} myName={myName} show={show}
              colAction={colAction} requestMaterials={requestMaterials} conclude={conclude}
              justifyDelay={justifyDelay} setDetailSvc={()=>{}}/>
          </div>
        )}

        {/* Admin emit button */}
        {canManage&&svc.status==="Rascunho"&&(svc.assignees||[]).length>0&&(
          <div style={{marginBottom:16}}>
            <Btn full onClick={()=>{emit(svc);onClose();}} style={{background:`linear-gradient(90deg,${T.accent},#2563EB)`,color:"#fff",border:"none"}}>
              📤 Emitir Serviço para Colaboradores
            </Btn>
          </div>
        )}

        {/* Timeline */}
        {(svc.timeline||[]).length>0&&(
          <div>
            <div style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:.8,marginBottom:10}}>📜 Histórico</div>
            <div style={{display:"flex",flexDirection:"column",gap:0}}>
              {[...(svc.timeline||[])].reverse().map((ev,i)=>(
                <div key={i} style={{display:"flex",gap:12,paddingBottom:12,position:"relative"}}>
                  <div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
                    <div style={{width:10,height:10,borderRadius:"50%",background:T.accent,flexShrink:0,marginTop:4}}/>
                    {i<(svc.timeline||[]).length-1&&<div style={{width:2,flex:1,background:`${T.accent}33`,marginTop:2}}/>}
                  </div>
                  <div style={{flex:1,paddingBottom:4}}>
                    <div style={{fontWeight:600,color:T.text,fontSize:13}}>{ev.action}</div>
                    {ev.note&&<div style={{fontSize:12,color:T.muted,marginTop:2}}>{ev.note}</div>}
                    <div style={{fontSize:10,color:T.muted,marginTop:4}}>
                      {ev.actor} · {new Date(ev.ts).toLocaleString("pt-BR")}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// ADMIN PANEL
// ═══════════════════════════════════════════════════════════════════════════════

export { ServiceDenyModal, PauseTaskModal, MaterialsModal, NFModal, ServiceDetailModal };
